/* Coordinate only the duplicate Clarity Brand Agents preview launcher.
   No analytics, app settings, network requests or payment behavior are changed. */
(() => {
  'use strict';
  if (window.__ekAssistantBoundaryReady) return;
  window.__ekAssistantBoundaryReady = true;
  const media = window.matchMedia('(max-width:767px)');
  let host = null, panel = null, hostObserver = null, panelObserver = null;
  let hiddenByUs = false, previousDisplay = '', previousPriority = '', queued = false;
  const shouldHide = () => document.documentElement.hasAttribute('data-ek-digital-pdp') ||
    (media.matches && !!document.querySelector('.productView')) || !!(panel && !panel.hidden);
  function apply() {
    queued = false;
    const nextHost = document.getElementById('clarity-agents-preview-host');
    const nextPanel = document.getElementById('ek-chat-panel');
    if (nextPanel !== panel) {
      if (panelObserver) panelObserver.disconnect();
      panel = nextPanel;
      if (panel) {
        panelObserver = new MutationObserver(schedule);
        panelObserver.observe(panel, { attributes: true, attributeFilter: ['hidden'] });
      }
    }
    if (nextHost !== host) {
      if (hostObserver) hostObserver.disconnect();
      host = nextHost;
      hiddenByUs = false;
      if (host) {
        hostObserver = new MutationObserver(schedule);
        hostObserver.observe(host, { attributes: true, attributeFilter: ['style'] });
      }
    }
    if (!host) return;
    if (shouldHide()) {
      if (!hiddenByUs) {
        previousDisplay = host.style.getPropertyValue('display');
        previousPriority = host.style.getPropertyPriority('display');
        hiddenByUs = true;
      }
      // Compare both fields before writing: own observer notification is then a no-op.
      if (host.style.getPropertyValue('display') !== 'none' || host.style.getPropertyPriority('display') !== 'important') {
        host.style.setProperty('display', 'none', 'important');
      }
    } else if (hiddenByUs) {
      hiddenByUs = false;
      if (previousDisplay) host.style.setProperty('display', previousDisplay, previousPriority);
      else host.style.removeProperty('display');
    }
  }
  function schedule() {
    if (!queued) { queued = true; window.requestAnimationFrame(apply); }
  }
  const treeObserver = new MutationObserver(records => {
    // Child insertion/removal catches replaced preview hosts; style mutations are
    // handled only by the targeted observer above, never the whole page.
    if (records.some(record => record.addedNodes.length || record.removedNodes.length)) schedule();
  });
  treeObserver.observe(document.documentElement, { childList: true, subtree: true });
  media.addEventListener('change', schedule);
  window.addEventListener('pageshow', schedule);
  apply();
})();
